module.exports = __webpack_public_path__ + "static/media/icon_7.39219d32.svg";